import { render, staticRenderFns } from "./ProductItemCard.vue?vue&type=template&id=f86f5738&scoped=true&"
import script from "./ProductItemCard.vue?vue&type=script&lang=js&"
export * from "./ProductItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemCard.vue?vue&type=style&index=0&id=f86f5738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86f5738",
  null
  
)

export default component.exports